declare var $: any;

export class AdminRefHouses {
    static bindEvents() {
        $("#ProcurementModel").change(function () {
            const val = $(this).val();
            var subItems = "";
            $.getJSON("getproductselectlistitems", { procurementModel: val }, (data: any) => {
                $.each(data, (index: any, item: any) => {
                    subItems += "<option value='" + item.Value + "'>" + item.Text + "</option>";
                });
                $("#SelectedProductId").html(subItems);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/scripts/partials/adminRefHouses.ts